import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { MaterialTreeNode } from "../../MaterialInterface.type";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { NgClass } from "@angular/common";

/**
 * Two-level checkbox tree of `MaterialTreeNode` (parents with children) with tri-state parent selection.
 * Emits `selectedChange`, `expandedUpdate` (whether all nodes are expanded) and `parentExpanded`.
 */
@Component({
  selector: "app-material-tree",
  templateUrl: "./material-tree.component.html",
  styleUrls: ["./material-tree.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatIconModule, NgClass, MatCheckboxModule, FormsModule]
})
export class MaterialTreeComponent implements OnInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  @Input()
  get nodes(): MaterialTreeNode[] {
    return this._nodes;
  }
  set nodes(nodes: MaterialTreeNode[]) {
    this._nodes = nodes;
    if (this._nodes) {
      this.checkAllSelected();
    }
  }
  _nodes: MaterialTreeNode[];
  @Output() expandedUpdate = new EventEmitter<boolean>();
  @Output() selectedChange = new EventEmitter<any>();
  @Output() parentExpanded = new EventEmitter<any>();

  /***************************************************************************/
  // ANCHOR Component initialization
  /***************************************************************************/

  ngOnInit(): void {
    this.checkAllSelected();
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  // Check expansion state
  checkAllExpanded(): void {
    this.expandedUpdate.emit(this._nodes.every((node: MaterialTreeNode) => node.expanded));
  }

  // Update selection
  updateSelection(parentNode?: MaterialTreeNode): void {
    if (parentNode) {
      parentNode.children.forEach((node: MaterialTreeNode) => (node.checked = parentNode.checked));
    } else {
      this.checkAllSelected();
    }
    this.selectedChange.emit();
  }

  // Check full or partial selection
  checkAllSelected(): void {
    this._nodes.forEach((node: MaterialTreeNode) => {
      if (node.children.every((node: MaterialTreeNode) => node.checked)) {
        node.checked = true;
        node.indeterminate = false;
      } else {
        node.checked = false;
        node.indeterminate = node.children.some((node: MaterialTreeNode) => node.checked);
      }
    });
  }
}
